import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspQuotationDetailsComponent } from './asp-quotation-details.component';
import { Routes, RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

const routes: Routes = [
  {
    path: 'quote-details/:encoded',
    component: AspQuotationDetailsComponent,
  },
];

@NgModule({
  declarations: [
    AspQuotationDetailsComponent,
    // ConfirmationPopupComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    MatTabsModule,
    CommonModule,
    MatCheckboxModule,
    FormsModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatIconModule,
        // MatListModule,
        MatDialogModule,
        // MatDividerModule,
        BrowserModule,
        MatCardModule,
    // MatProgressBarModule,
    // MatIconModule,
    // MatDialogModule,
    // FormsModule,
    // ReactiveFormsModule, // Add ReactiveFormsModule
    // MatFormFieldModule,
    // MatInputModule // Add MatInputModule
       MatBottomSheetModule,
        MatButtonModule,
        MatIconModule,
        // MatListModule,
        MatDialogModule,
        // MatDividerModule,
        BrowserModule,
        MatCardModule,
        // MatBottomSheet,
        MatFormFieldModule,
        MatInputModule,

  ],
  // entryComponents: [
    // ConfirmationPopupComponent
  // ],
  exports: [AspQuotationDetailsComponent],
})

export class AspQuotationDetailsModule { }
